import * as reg from './regular-expressions';
import { Decimal } from 'decimal.js';

export class Utility {
    static isEmpty(value) {
        if (!value) {
            return true;

        }

        return value == null || this.trim(value) === '' || value.length === 0;
    }

    static isNotEmpty(value) {
        return !this.isEmpty(value);
    }

    static isInteger(value) {
        return this.isNotEmpty(value) && reg.ONLY_DIGIT.test(this.trim(value));
    }

    static isIntegerGreaterThan(value, base) {
        return this.isInteger(value) && value > base;
    }

    static isIntegerGreaterThanEqual(value, base) {
        return this.isInteger(value) && value >= base;
    }

    static isValidPositiveInteger(value) {
        return this.isEmpty(value) || this.isIntegerGreaterThanEqual(value, 1);
    }
    static isFloat(value) {
        return this.isNotEmpty(value) && reg.SIMPLE_NUMBER.test(this.trim(value));
    }

    static isFloatGreaterThan(value, base) {
        return this.isFloat(value) && value > base;
    }

    static isFloatGreaterThanEqual(value, base) {
        return this.isFloat(value) && value >= base;
    }

    static isFloatGreatThanAndLessThanEqual(value, base1, base2) {
        return this.isFloat(value) && (value > base1) && (value <= base2);
    }

    static isFloatGreatThanAndLessThan(value, base1, base2) {
        return this.isFloat(value) && (value > base1) && (value < base2);
    }

    static getFixedSd(fixedSdFieldValue: number, fixedMean: number, percentSDFlag: boolean) {
        return percentSDFlag
        ? (fixedSdFieldValue * fixedMean / 100)
        : fixedSdFieldValue;
    }

    static getPercentageFromFraction(fractionalValue: any) {
        return this.isFloat(fractionalValue) ? (new Decimal(fractionalValue)).times(100).toNumber() : fractionalValue;
    }

    static getFractionFromPercentage(percentageValue: any) {
        return this.isFloat(percentageValue) ? (new Decimal(percentageValue)).dividedBy(100).toNumber() : percentageValue;
    }

    static toNumber(value) {
        if (!value || this.isEmpty(value)) {
            return;
        }

        const result = +this.trim(value);
        if (isNaN(result)) {
            return;
        }

        return result;
    }

    static trim(value) {
        if (value && value.trim) {
            return value.trim();
        }
        return value;
    }

    static promiseFactory<T>(): { promise: Promise<T>, resolve: any, reject: any } {
        let resolve;
        let reject;
        const promise = new Promise<T>((_resolve, _reject) => { resolve = _resolve; reject = _reject; });
        return { promise, resolve, reject };
    }

    static isDateExpired(date): boolean {
        const currentDate = new Date(Date.now());
        return new Date(date)
            < new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0, 0);
    }

    static getProperty(propertyName, object) {

        const parts = propertyName.split('.'),
            length = parts.length;
        let property = object || this;

        for (let i = 0; i < length; i++) {
            property = property[parts[i]];
        }

        return property;
    }

    static sanitizePath(path: string) {
        if (path.endsWith('/') || path.endsWith('\\')) {
            return path;
        }

        return `${path}/`;
    }

    static createImmutableObject<T>(current: T, source: T): T {
        return Object.assign({}, current, source) as T;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/helpers/utility.ts